export default {
  'introduction': {
    title: 'INTRODUCTION',
    description:
      '<p>' +
      '  ターゲットは悪人のみ！騙して騙して騙しまくる！？<br>' +
      '  ロサンゼルス、シンガポール、ロンドン、上海、そして東京…<br>' +
      '  世界を股にかけた壮大な＜コン・ゲーム＞、ここに開幕！！！' +
      '</p>',
    text:
      '<p>自称“日本一の天才詐欺師”枝村真人。' +
      '<br>その日も相棒の工藤と2人で浅草観光に来ているフランス人に詐欺を仕掛けてひと儲け…のはずが、逆に騙され大金を奪われてしまう。その男はローラン・ティエリー、マフィアさえ手玉に取るコンフィデンスマンだったのだ。' +
      '<br>世界を舞台に仕掛ける桁違いの騙し合いに、枝村は巻き込まれていく…!!' +
      '<br>＜鏑木ひろ×貞本義行×古沢良太×WIT STUDIO＞今世紀最強のチームが贈る、最高の痛快クライム・エンタテインメント！</p>'
  },
  '1': {
    no: '#1',
    caseId: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    subTitle: 'LOS ANGELES CONNECTION',
    description: '自称“日本一の詐欺師”こと枝村真人（エダマメ）は、年寄りや旅行客相手に詐欺を働いていた。',
    image: '/assets/images/story-1-1.jpg',
    images: [
      '/assets/images/story-1-1.jpg',
      '/assets/images/story-1-2.jpg',
      '/assets/images/story-1-3.jpg',
      '/assets/images/story-1-4.jpg',
      '/assets/images/story-1-5.jpg',
      '/assets/images/story-1-6.jpg',
      '/assets/images/story-1-7.jpg',
      '/assets/images/story-1-8.jpg',
      '/assets/images/story-1-9.jpg',
      '/assets/images/story-1-10.jpg'
    ],
    text:
      '<p><em>「俺が間違えるわけねえだろ！」</em></p>' +
      '<p>自称“日本一の詐欺師”こと枝村真人（エダマメ）は、年寄りや旅行客相手に詐欺を働いていた。' +
      '<br>そんなある日、標的に選んだ外国人バックパッカーはまさかの同業者だった！' +
      '<br>彼の名はローラン・ティエリー。エダマメを気に入ったローランは、ロサンゼルス・ハリウッドで“ある勝負”を提案する。</p>'
  },
  '2': {
    no: '#2',
    caseId: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    subTitle: 'LOS ANGELES CONNECTION',
    description: 'ハリウッドの映画プロデューサー、エディ・カッサーノは、ロサンゼルスを牛耳るマフィアだった。',
    image: '/assets/images/story-2-1.jpg',
    images: [
      '/assets/images/story-2-1.jpg',
      '/assets/images/story-2-2.jpg',
      '/assets/images/story-2-3.jpg',
      '/assets/images/story-2-4.jpg',
      '/assets/images/story-2-5.jpg',
      '/assets/images/story-2-6.jpg',
      '/assets/images/story-2-7.jpg',
      '/assets/images/story-2-8.jpg',
      '/assets/images/story-2-9.jpg',
      '/assets/images/story-2-10.jpg'
    ],
    text:
      '<p><em>「人々が信じたいのは、自分に都合のいい真実さ」</em></p>' +
      '<p>ハリウッドの映画プロデューサー、エディ・カッサーノは、ロサンゼルスを牛耳るマフィアだった。偽の合成麻薬「サクラマジック」を奴に売りさばこうと誘うローラン。だが、臆病風に吹かれたエダマメは…。</p>'
  },
  '3': {
    no: '#3',
    caseId: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    subTitle: 'LOS ANGELES CONNECTION',
    description: '映画を通じてカッサーノと意気投合したエダマメ。',
    image: '/assets/images/story-3-1.jpg',
    images: [
      '/assets/images/story-3-1.jpg',
      '/assets/images/story-3-2.jpg',
      '/assets/images/story-3-3.jpg',
      '/assets/images/story-3-4.jpg',
      '/assets/images/story-3-5.jpg',
      '/assets/images/story-3-6.jpg',
      '/assets/images/story-3-7.jpg',
      '/assets/images/story-3-8.jpg',
      '/assets/images/story-3-9.jpg',
      '/assets/images/story-3-10.jpg'
    ],
    text:
      '<p><em>「映画への愛さなければ、こげな映画作れねえ！」</em></p>' +
      '<p>映画を通じてカッサーノと意気投合したエダマメ。「サクラマジック」の独占販売だけではなく、製造レシピ受け渡しを条件に、さらなる高額ディールを引き出すことに成功する。順調に運ぶ計画の裏でロス市警、さらにFBIが動き出す…！</p>'
  },
  '4': {
    no: '#4',
    caseId: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    subTitle: 'LOS ANGELES CONNECTION',
    description: '麻薬製造工場の改修が始まり、エダマメはカッサーノのボディガード・サラザールと共に過ごすことに。',
    image: '/assets/images/story-4-1.jpg',
    images: [
      '/assets/images/story-4-1.jpg',
      '/assets/images/story-4-2.jpg',
      '/assets/images/story-4-3.jpg',
      '/assets/images/story-4-4.jpg',
      '/assets/images/story-4-5.jpg',
      '/assets/images/story-4-6.jpg',
      '/assets/images/story-4-7.jpg',
      '/assets/images/story-4-8.jpg',
      '/assets/images/story-4-9.jpg',
      '/assets/images/story-4-10.jpg'
    ],
    text:
      '<p><em>「サラザールさ見逃せ…！」</em></p>' +
      '<p>麻薬製造工場の改修が始まり、エダマメはカッサーノのボディガード・サラザールと共に過ごすことに。遊園地でサラザールの息子トムと遊ぶうちに、かつての自分を思い出すエダマメ。そこへカッサーノとローランの逮捕を画策するＦＢＩ特別捜査官ポーラ・ディキンスが現れる！</p>'
  },
  '5': {
    no: '#5',
    caseId: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    subTitle: 'LOS ANGELES CONNECTION',
    description: '工場の改修も終わり、最後の取引条件〝エダマメ本人による製造実演”が始まった…！',
    image: '/assets/images/story-5-1.jpg',
    images: [
      '/assets/images/story-5-1.jpg',
      '/assets/images/story-5-2.jpg',
      '/assets/images/story-5-3.jpg',
      '/assets/images/story-5-4.jpg',
      '/assets/images/story-5-5.jpg',
      '/assets/images/story-5-6.jpg',
      '/assets/images/story-5-7.jpg',
      '/assets/images/story-5-8.jpg',
      '/assets/images/story-5-9.jpg',
      '/assets/images/story-5-10.jpg'
    ],
    text:
      '<p><em>「キミはいいコンフィデンスマンになるよ。勤勉で、繊細で、度胸がある」</em></p>' +
      '<p>工場の改修も終わり、最後の取引条件“エダマメ本人による製造実演”が始まった…！ローラン、カッサーノ、ポーラ、そしてエダマメ、それぞれの思惑が入り乱れるなか、いよいよ「サクラマジック」をめぐる取引が成立する…！<br>' +
      '最後に笑うのはマフィアか、コンフィデンスマンか、FBIか…？</p>'
  },
  '6': {
    no: '#6',
    caseId: 'CASE 2',
    title: 'シンガポール・スカイ',
    subTitle: 'SINGAPORE SKY',
    description: '',
    image: '/assets/images/story-6-1.jpg',
    images: [
      '/assets/images/story-6-1.jpg',
      '/assets/images/story-6-2.jpg',
      '/assets/images/story-6-3.jpg',
      '/assets/images/story-6-4.jpg',
      '/assets/images/story-6-5.jpg',
      '/assets/images/story-6-6.jpg',
      '/assets/images/story-6-7.jpg',
      '/assets/images/story-6-8.jpg',
      '/assets/images/story-6-9.jpg',
      '/assets/images/story-6-10.jpg'
    ],
    text:
      '<p><em>「オラのことは忘れてくれ…」</em></p>' +
      '<p>刑期を終えたエダマメは田舎の整備工場で働き始める。ひたむきに手を動かし続けるエダマメ。その真面目さを気に入られ、海外で開催される『エアレース』の仕事を紹介して貰う。トントン拍子に進んだ先で、聞き覚えのある声がして…</p>'
  },
  '7': {
    no: '#7',
    caseId: 'CASE 2',
    title: 'シンガポール・スカイ',
    subTitle: 'SINGAPORE SKY',
    description: '',
    image: '/assets/images/story-7-1.jpg',
    images: [
      '/assets/images/story-7-1.jpg',
      '/assets/images/story-7-2.jpg',
      '/assets/images/story-7-3.jpg',
      '/assets/images/story-7-4.jpg',
      '/assets/images/story-7-5.jpg',
      '/assets/images/story-7-6.jpg',
      '/assets/images/story-7-7.jpg',
      '/assets/images/story-7-8.jpg',
      '/assets/images/story-7-9.jpg',
      '/assets/images/story-7-10.jpg'
    ],
    text:
      '<p><em>「死ぬためさ」</em></p>' +
      '<p>人気急上昇中の『パスファインダー・エアレース』。しかしモータースポーツとは名ばかりの、イブラヒム兄弟が主催する八百長レース・ショーだった！調子が上がらないアビーを心配するシンシア。ローラン達は新進気鋭のゲストチームとして、レースに参戦する。</p>'
  },
  '8': {
    no: '#8',
    caseId: 'CASE 2',
    title: 'シンガポール・スカイ',
    subTitle: 'SINGAPORE SKY',
    description: '',
    image: '/assets/images/story-8-1.jpg',
    images: [
      '/assets/images/story-8-1.jpg',
      '/assets/images/story-8-2.jpg',
      '/assets/images/story-8-3.jpg',
      '/assets/images/story-8-4.jpg',
      '/assets/images/story-8-5.jpg',
      '/assets/images/story-8-6.jpg',
      '/assets/images/story-8-7.jpg',
      '/assets/images/story-8-8.jpg',
      '/assets/images/story-8-9.jpg',
      '/assets/images/story-8-10.jpg'
    ],
    text:
      '<p><em>「ルイスは元軍人か？」</em></p>' +
      '<p>唯一の女性パイロットチームとしてレースに挑むアビーとシンシア。一方、サム・イブラヒムを嵌めるため、裏カジノの準備に取り掛かるローランとエダマメ。クラークの元ライバルだったルイスとその妻イザベルを呼び出したローランは、二人にコンゲームへの参加を持ち掛けるが…。</p>'
  },
  '9': {
    no: '#9',
    caseId: 'CASE 2',
    title: 'シンガポール・スカイ',
    subTitle: 'SINGAPORE SKY',
    description: '',
    image: '/assets/images/story-9-1.jpg',
    images: [
      '/assets/images/story-9-1.jpg',
      '/assets/images/story-9-2.jpg',
      '/assets/images/story-9-3.jpg',
      '/assets/images/story-9-4.jpg',
      '/assets/images/story-9-5.jpg',
      '/assets/images/story-9-6.jpg',
      '/assets/images/story-9-7.jpg',
      '/assets/images/story-9-8.jpg',
      '/assets/images/story-9-9.jpg',
      '/assets/images/story-9-10.jpg'
    ],
    text:
      '<p><em>「答えろ…」</em></p>' +
      '<p>勝ち進むアビーに大金を賭け続けるサム。金庫の金が底を尽きかけ、ローランはサムを出禁にする。空を自由に飛ぶ機体を羨望の眼差しで見るルイス。その様子を見守るイザベル。過去の因縁を胸に秘め、アビーは静かに行動を起こす。</p>'
  },
  '10': {
    no: '#10',
    caseId: 'CASE 2',
    title: 'シンガポール・スカイ',
    subTitle: 'SINGAPORE SKY',
    description: '',
    image: '/assets/images/story-10-1.jpg',
    images: [
      '/assets/images/story-10-1.jpg',
      '/assets/images/story-10-2.jpg',
      '/assets/images/story-10-3.jpg',
      '/assets/images/story-10-4.jpg',
      '/assets/images/story-10-5.jpg',
      '/assets/images/story-10-6.jpg',
      '/assets/images/story-10-7.jpg',
      '/assets/images/story-10-8.jpg',
      '/assets/images/story-10-9.jpg',
      '/assets/images/story-10-10.jpg'
    ],
    text:
      '<p><em>「いっぺん、オラと死んでみるべ」</em></p>' +
      '<p>ルイスが元軍人と知り、接近するアビー。一触即発の二人。そして、レースはいよいよ決勝戦当日。裏カジノに再び現れたサム、空へ飛び立つアビー機とクラーク機。ポーカーフェイスのローラン、後ろめたいエダマメ…。勝利の花火はどちらの色に染まるのか…！？</p>'
  },
  '11': {
    no: '#11',
    caseId: 'CASE 3',
    title: 'スノー・オブ・ロンドン',
    subTitle: 'SNOW OF LONDON',
    description: '',
    image: '/assets/images/story-11-1.jpg',
    images: [
      '/assets/images/story-11-1.jpg',
      '/assets/images/story-11-2.jpg',
      '/assets/images/story-11-3.jpg',
      '/assets/images/story-11-4.jpg',
      '/assets/images/story-11-5.jpg',
      '/assets/images/story-11-6.jpg',
      '/assets/images/story-11-7.jpg',
      '/assets/images/story-11-8.jpg',
      '/assets/images/story-11-9.jpg',
      '/assets/images/story-11-10.jpg'
    ],
    text:
      '<p><em>「絵を描く男は嫌いなの」</em></p>' +
      '<p>ローラン達とは距離を置き、エダマメはフランスで新しい生活を始める。<br>そんな折、下宿で世話になってる親子から店を畳むことを聞かされる。理由は借金。いつものお節介から、下宿先に飾ってあった古い絵を売り払い、借金を返済しようと奮闘するエダマメだったが… </p>'
  },
  '12': {
    no: '#12',
    caseId: 'CASE 3',
    title: 'スノー・オブ・ロンドン',
    subTitle: 'SNOW OF LONDON',
    description: '',
    image: '/assets/images/story-12-1.jpg',
    images: [
      '/assets/images/story-12-1.jpg',
      '/assets/images/story-12-2.jpg',
      '/assets/images/story-12-3.jpg',
      '/assets/images/story-12-4.jpg',
      '/assets/images/story-12-5.jpg',
      '/assets/images/story-12-6.jpg',
      '/assets/images/story-12-7.jpg',
      '/assets/images/story-12-8.jpg',
      '/assets/images/story-12-9.jpg',
      '/assets/images/story-12-10.jpg'
    ],
    text:
      '<p><em>「絵のモデルになってくれないか？」</em></p>' +
      '<p>エダマメが売りつけた相手は、イギリスの美術界に君臨する画商でオークショニアのジェームズ・コールマンだった。安値で売り飛ばした名画「ロンドンの雪」を取り戻すため、エダマメたちはコールマン主催のオークションへ乗り込む！</p>'
  },
  '13': {
    no: '#13',
    caseId: 'CASE 3',
    title: 'スノー・オブ・ロンドン',
    subTitle: 'SNOW OF LONDON',
    description: '',
    image: '/assets/images/story-13-1.jpg',
    images: [
      '/assets/images/story-13-1.jpg',
      '/assets/images/story-13-2.jpg',
      '/assets/images/story-13-3.jpg',
      '/assets/images/story-13-4.jpg',
      '/assets/images/story-13-5.jpg',
      '/assets/images/story-13-6.jpg',
      '/assets/images/story-13-7.jpg',
      '/assets/images/story-13-8.jpg',
      '/assets/images/story-13-9.jpg',
      '/assets/images/story-13-10.jpg'
    ],
    text:
      '<p><em>「今はまだ本物をあげられないけど」</em></p>' +
      '<p>コールマンを偽のオークションへ招待し、贋作を買わせようと企てるシンシア。一方エダマメは、トーマス・メイヤーという男を訪ね「ロンドンの雪」の贋作制作を依頼する。かつてコールマンにそそのかされて贋作を手掛けたトーマスは、シンシアがどうしても忘れられない男だった。</p>'
  },
  '14': {
    no: '#14',
    caseId: 'CASE 3',
    title: 'スノー・オブ・ロンドン',
    subTitle: 'SNOW OF LONDON',
    description: '',
    image: '/assets/images/story-14-1.jpg',
    images: [
      '/assets/images/story-14-1.jpg',
      '/assets/images/story-14-2.jpg',
      '/assets/images/story-14-3.jpg',
      '/assets/images/story-14-4.jpg',
      '/assets/images/story-14-5.jpg',
      '/assets/images/story-14-6.jpg',
      '/assets/images/story-14-7.jpg',
      '/assets/images/story-14-8.jpg',
      '/assets/images/story-14-9.jpg',
      '/assets/images/story-14-10.jpg'
    ],
    text:
      '<p><em>「男は悲しい生き物だね」</em></p>' +
      '<p>贋作「ロンドンの雪」が完成する。その出来映えに驚くエダマメ。そして舞台は古城のオークション会場へ…。ローランの仕切りで始まった偽オークションは「ロンドンの雪」の登場でクライマックスを迎える。コールマンとシンシアの因縁の対決…！果たして、名画の行方はどちらの手に…！？</p>'
  },
  '15': {
    no: '#15',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-15-1.jpg',
    images: [
      '/assets/images/story-15-1.jpg',
      '/assets/images/story-15-2.jpg',
      '/assets/images/story-15-3.jpg',
      '/assets/images/story-15-4.jpg',
      '/assets/images/story-15-5.jpg',
      '/assets/images/story-15-6.jpg',
      '/assets/images/story-15-7.jpg',
      '/assets/images/story-15-8.jpg',
      '/assets/images/story-15-9.jpg',
      '/assets/images/story-15-10.jpg'
    ],
    text:
      '<p><em>「お別れを言いに来ただ」</em></p>' +
      '<p>母の墓前で今まで溜め込んでいた気持ちを吐き出し、ローラン達と決別したエダマメは貿易会社「スカーレット商会」に就職する。しかし、会社の裏側が見えたとき、またもローランの掌に踊らされたと気づくエダマメ。今回のターゲットはスカーレット商会の親会社『朱雀連合会』。そこはボスの朱雀アケミが人身売買を生業とする犯罪組織だった…！</p>'
  },
  '16': {
    no: '#16',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-16-1.jpg',
    images: [
      '/assets/images/story-16-1.jpg',
      '/assets/images/story-16-2.jpg',
      '/assets/images/story-16-3.jpg',
      '/assets/images/story-16-4.jpg',
      '/assets/images/story-16-5.jpg',
      '/assets/images/story-16-6.jpg',
      '/assets/images/story-16-7.jpg',
      '/assets/images/story-16-8.jpg',
      '/assets/images/story-16-9.jpg',
      '/assets/images/story-16-10.jpg'
    ],
    text:
      '<p><em>「逃げるって…どこに？」</em></p>' +
      '<p>自分が犯罪組織に居ると知りすっかり意気消沈のエダマメ。ある日、シンシアとシウォンがスカーレット商会に訪れる。彼女たちが持ち掛けたのは中東の王女の誘拐見学、及び人身売買だった。帰国後、手筈通り会社に囚われた王女だけを逃がそうとするエダマメだったが…</p>'
  },
  '17': {
    no: '#17',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-17-1.jpg',
    images: [
      '/assets/images/story-17-1.jpg',
      '/assets/images/story-17-2.jpg',
      '/assets/images/story-17-3.jpg',
      '/assets/images/story-17-4.jpg',
      '/assets/images/story-17-5.jpg',
      '/assets/images/story-17-6.jpg',
      '/assets/images/story-17-7.jpg',
      '/assets/images/story-17-8.jpg',
      '/assets/images/story-17-9.jpg',
      '/assets/images/story-17-10.jpg'
    ],
    text:
      '<p><em>「人から尊敬される人間であること」</em></p>' +
      '<p>アケミに気に入られたエダマメは、朱雀連合会の下部組織『上海龍虎幇（シャンハイロンフーバン）』との通訳に抜擢される。あくる日、上海龍虎幇のNo.2である陳が訪れる。上海側の通訳に現れたのは、オズと呼ばれる日本人。エダマメはオズの声を耳にした瞬間、言葉を失う…。</p>'
  },
  '18': {
    no: '#18',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-18-1.jpg',
    images: [
      '/assets/images/story-18-1.jpg',
      '/assets/images/story-18-2.jpg',
      '/assets/images/story-18-3.jpg',
      '/assets/images/story-18-4.jpg',
      '/assets/images/story-18-5.jpg',
      '/assets/images/story-18-6.jpg',
      '/assets/images/story-18-7.jpg',
      '/assets/images/story-18-8.jpg',
      '/assets/images/story-18-9.jpg',
      '/assets/images/story-18-10.jpg'
    ],
    text:
      '<p><em>「少し話そう…」</em></p>' +
      '<p>救出作戦は失敗に終わる。クルーザーの上に並ばされ絶体絶命のエダマメたち。銃で撃たれ海中に沈む仲間。激昂するエダマメだったが、アケミの一言で事態は収束を迎える。季節は変わりアケミの側近として働くエダマメだったが、ある日死んだはずの男が現れ、その口から過去の因縁が語られる。</p>'
  },
  '19': {
    no: '#19',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-19-1.jpg',
    images: [
      '/assets/images/story-19-1.jpg',
      '/assets/images/story-19-2.jpg',
      '/assets/images/story-19-3.jpg',
      '/assets/images/story-19-4.jpg',
      '/assets/images/story-19-5.jpg',
      '/assets/images/story-19-6.jpg',
      '/assets/images/story-19-7.jpg',
      '/assets/images/story-19-8.jpg',
      '/assets/images/story-19-9.jpg',
      '/assets/images/story-19-10.jpg'
    ],
    text:
      '<p><em>「…あんたら何者だ？」</em></p>' +
      '<p>若きローランはある男への復讐に凶刃を振るうも、たまたま居合わせた女性を刺してしまう。なんとかその場を逃げ出したローランだが、刺された女性「ドロシー」はなんとローランの前へ再び姿を現し、真実を語るのだった…。</p>'
  },
  '20': {
    no: '#20',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-20-1.jpg',
    images: [
      '/assets/images/story-20-1.jpg',
      '/assets/images/story-20-2.jpg',
      '/assets/images/story-20-3.jpg',
      '/assets/images/story-20-4.jpg',
      '/assets/images/story-20-5.jpg',
      '/assets/images/story-20-6.jpg',
      '/assets/images/story-20-7.jpg',
      '/assets/images/story-20-8.jpg',
      '/assets/images/story-20-9.jpg',
      '/assets/images/story-20-10.jpg'
    ],
    text:
      '<p><em>「最後のお仕事だもんね、楽しくやりましょう」</em></p>' +
      '<p>ドロシー達は盛大なフィナーレを飾るべく、上海龍虎幇にアプローチする。エチオピア王朝のプリンセスを餌に、オズの筋書き通りに事は運ばれて行く。順調に進む作戦、安堵感がローラン達に広がったその時…</p>'
  },
  '21': {
    no: '#21',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-21-1.jpg',
    images: [
      '/assets/images/story-21-1.jpg',
      '/assets/images/story-21-2.jpg',
      '/assets/images/story-21-3.jpg',
      '/assets/images/story-21-4.jpg',
      '/assets/images/story-21-5.jpg',
      '/assets/images/story-21-6.jpg',
      '/assets/images/story-21-7.jpg',
      '/assets/images/story-21-8.jpg',
      '/assets/images/story-21-9.jpg',
      '/assets/images/story-21-10.jpg'
    ],
    text:
      '<p><em>「やるよ。言われた通りに」</em></p>' +
      '<p>オズからこれまでの経緯を伝えられたエダマメ。母親と自分を捨てた父に、不信感を抱きつつも協力を約束する。積年の恨みを胸に抱き、上海龍虎幇の元へ向かうローラン。いよいよ、物語は最終局面へ！</p>'
  },
  '22': {
    no: '#22',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-22-1.jpg',
    images: [
      '/assets/images/story-22-1.jpg',
      '/assets/images/story-22-2.jpg',
      '/assets/images/story-22-3.jpg',
      '/assets/images/story-22-4.jpg',
      '/assets/images/story-22-5.jpg',
      '/assets/images/story-22-6.jpg',
      '/assets/images/story-22-7.jpg',
      '/assets/images/story-22-8.jpg',
      '/assets/images/story-22-9.jpg',
      '/assets/images/story-22-10.jpg'
    ],
    text:
      '<p><em>「やっと、勝てた…！」</em></p>' +
      '<p>ついに朱雀連合会のアケミの元に上海龍虎幇の劉が訪れる。下剋上を狙うは劉、粛清の機会を窺うアケミ。役者が揃った会長室で、最後に笑うのは果たして…！？</p>'
  },
  '23': {
    no: '#23',
    caseId: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト',
    subTitle: 'WIZARD OF FAR EAST',
    description: '',
    image: '/assets/images/story-23-1.jpg',
    images: [
      '/assets/images/story-23-1.jpg',
      '/assets/images/story-23-2.jpg',
      '/assets/images/story-23-3.jpg',
      '/assets/images/story-23-4.jpg',
      '/assets/images/story-23-5.jpg',
      '/assets/images/story-23-6.jpg',
      '/assets/images/story-23-7.jpg',
      '/assets/images/story-23-8.jpg',
      '/assets/images/story-23-9.jpg',
      '/assets/images/story-23-10.jpg'
    ],
    text:
      '<p><em>「自分を許してやれって」</em></p>' +
      '<p>長い年月を費やしたミッションはビルの崩壊と共に終わりを迎えた。頑なだったエダマメの心を変えたのは、母親と『或る詐欺師』の言葉だった。復讐を終えた一同は…</p>'
  }
}



// WEBPACK FOOTER //
// ./src/data/story.js